<template>
  <dialog-popup
    :dialog="show"
    @dialogItem="addDialogItems"
    @back="backDialog"
    @clearApiError="clearApiError"
    :label="'Department'"
    :ghostText="'+ Add'"
    description=""
    :type="type"
    :buttonLabel="saveButtonLabel"
    :orgObjectType="'department'"
    :isShowCharCounter="true"
    :maxWidth="'600'"
    :allowSpecialCharacters="true"
    :autoFocus="false"
    :apiError="errorMessage"
    :duplicateNotAllowed="true"
    :allowSaveWithApiError="true"
  />
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import DialogPopup from "@components/Modal/DialogPopup.vue";

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: "add",
  },
  errorMessage: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onAdd", "close", "clearError"]);

const instance = getCurrentInstance();
const proxy = instance?.proxy;

const saveButtonLabel = computed(() =>
  proxy?.$loader?.isAppLoading ? "Saving" : "Save as Draft"
);

function addDialogItems(data) {
  emit("onAdd", data);
}

function backDialog() {
  emit("close");
}

function clearApiError() {
  emit("clearError");
}
</script>
